import { useState } from "react";
import { useConfigPageContext } from "src/Contexts/configPagesContext/configPagesContext";
import { useLayoutMainContext } from "src/Contexts/MainLayoutContext";
import { api } from "src/shared/setup/API/api";

interface IUseFormEditarCodProposta {
  idContract: string;
  codProposta: string;
  setOpenModal: React.Dispatch<React.SetStateAction<boolean>>;
  onSuccess: () => void;
}

export const UseFormEditarCodProposta = ({
  idContract,
  codProposta,
  setOpenModal,
  onSuccess,
}: IUseFormEditarCodProposta) => {
  const { setAttTable } = useConfigPageContext();
  const { handleGetAlert } = useLayoutMainContext();

  const [loading, setLoading] = useState(false);

  const handleEditarCodProposta = async () => {
    if (!codProposta.trim()) {
      return handleGetAlert({ message: "Digite uma proposta !" });
    }

    setLoading(true);

    await api
      .patch(`/contratos/${idContract}/cod-proposta`, {
        cod_proposta: codProposta.trim(),
      })
      .then((res) => {
        handleGetAlert({ message: res.data.message });
        setAttTable((item) => !item);
        setOpenModal(false);
        onSuccess();
      })
      .catch((error) =>
        handleGetAlert({ message: error.response.data.message })
      )
      .finally(() => setLoading(false));
  };

  return {
    handleEditarCodProposta,
    loading,
  };
};
